import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
var ListViewHeader = function (props) {
    return (React.createElement("div", { className: classNames('k-listview-header', props.className), style: props.style }, props.children));
};
export default ListViewHeader;
//# sourceMappingURL=ListViewHeader.js.map